export interface NotificationPropType {}

export enum NotificationType {
  SUCCESS,
  ERROR,
  NORMAL,
}
